<template>
  <v-snackbar
    v-model="snackbar"
    :color="snackbarAlert.color"
    :timeout="timeout"
    flat
    bottom
    left
    :class="[
      { 'v-snack--position': mainMenuIsOpen && !noMainMenu },
      { 'v-snack--position-alt': !mainMenuIsOpen && !noMainMenu }
    ]"
  >
    <span v-if="snackbarAlert.message" v-html="snackbarAlert.message" />
    <v-btn flat fab @click="snackbar = false">
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CorpSnackbar',
  computed: {
    ...mapState({
      snackbarAlert: state => state.snackbarAlert,
      mainMenuIsOpen: state => state.mainMenu.isOpen
    }),

    snackbar: {
      set () {
        this.clearAlert()
      },

      get () {
        return this.snackbarAlert.isVisible
      }
    },

    noMainMenu () {
      return this.$route.meta.noMainMenu
    }
  },
  data () {
    return {
      timeout: 5000
    }
  },
  methods: {
    ...mapActions({
      clearAlert: 'snackbarAlert/clear'
    })
  }
}
</script>

<style lang="scss">
.v-snack__content {
  height: auto;
  min-height: 48px;
  padding: 6px 24px;
}

.v-snack--position {

  @media (min-width: 1200px) {
    left: 256px;
  }
}

.v-snack--position-alt {

  @media (min-width: 1200px) {
    left: 73px;
  }
}

.v-snack__wrapper {
  box-shadow: none;
}
</style>
